import { LicensePackageOptions } from 'records/License';
import { environmentVars } from 'constants/services';

export const isBasicOrUnpaidTier = (
  licensePackage: LicensePackageOptions
): boolean => {
  return (
    (licensePackage === LicensePackageOptions.Basics ||
      licensePackage === LicensePackageOptions.Unpaid) &&
    !environmentVars.IGNORE_LICENSING_TIER
  );
};
